import { string } from 'prop-types';

export const propTypes = {
  collectionName: string.isRequired
};